import { PulseBetsTypes } from "../../../enums";
var ViewHelper = /** @class */ (function () {
    function ViewHelper() {
    }
    ViewHelper.getInstance = function () {
        if (!this.instance) {
            this.instance = new ViewHelper();
        }
        return this.instance;
    };
    ViewHelper.prototype.milliToMinutesString = function (totalMilli, cutZeroMinutes, eventTypeId) {
        var totalSecondsRounded = Math.round(totalMilli / 1000);
        if (totalSecondsRounded < 61 && cutZeroMinutes) {
            return eventTypeId === PulseBetsTypes.OneMinPulse || eventTypeId === PulseBetsTypes.ThirtySecPulse ?
                "" + totalSecondsRounded :
                this.numToStringWithZeroPadd(totalSecondsRounded);
        }
        else {
            var minutesPart = Math.floor(totalSecondsRounded / 60);
            var secondsPart = totalSecondsRounded % 60;
            return this.numToStringWithZeroPadd(minutesPart) + ":" + this.numToStringWithZeroPadd(secondsPart);
        }
    };
    ViewHelper.prototype.milliRangeToMinutesRange = function (milli1, milli2, eventTypeId) {
        var smallerThanMin = (milli1 < 61000 && milli2 < 61000);
        return this.milliToMinutesString(milli1, smallerThanMin, eventTypeId) + "-" + this.milliToMinutesString(milli2, smallerThanMin, eventTypeId);
    };
    ViewHelper.prototype.numToStringWithZeroPadd = function (num) {
        return (num < 10) ? "0" + num : "" + num;
    };
    return ViewHelper;
}());
export { ViewHelper };
//# sourceMappingURL=ViewHelper.js.map